<template>
<div class="role_div">
  <div class="title">
    <el-breadcrumb>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div class="center_box">
    <div class="center_title">
      <!-- @click="AddRole" -->
      <span class="center_left_btn" @click="handleClick(1)">新 增</span>
    </div>
    <div class="center-contain">
      <el-table :data="permissionList" :header-cell-style="{background:'#F5F6FA'}" style="width: 100%">
        <el-table-column align="center" prop="name" label="角色">
        </el-table-column>
        <el-table-column align="center" prop="describe" label="描述">
        </el-table-column>
        <el-table-column align="center" label="角色状态">
          <template slot-scope="scope">
            <div v-if="scope.row.status==1" class="RoleStatus">
              <div class="Yuan"> </div>
              <div class="name">启用</div>
            </div>
            <div v-else class="RoleStatus">
              <div class="RYuan"> </div>
              <div class="name">禁用</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleClick(2,scope.row)">编辑</el-button>
            <el-button @click="handleClick(3,scope.row)" type="text" size="small" class="deletcol">删除</el-button>

          </template>
        </el-table-column>
      </el-table>
       <div class="page">
      <el-pagination @size-change="sizeChange" @current-change="handleSizeChange" :current-page="page" :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="total" background>
      </el-pagination>
    </div>
    </div>
   
  </div>
</div>
</template>

<script>
import {
  mapActions
} from "vuex";
export default {
  props: {

  },
  data() {
    return {
      permissionList: [],
      total: 0,
      size: 10,
      page: 1,

    };
  },
  mounted() {
    this.GetRoleList()
  },
  methods: {
    ...mapActions({
      roleList: "pressimApi/roleList",
      DeleteRole: "pressimApi/DeleteRole",
    }),
    sizeChange(val) {
      this.size = val;
      this.GetRoleList()
    },
    handleSizeChange(val) {
      this.page = val;
      this.GetRoleList()
    },
    GetRoleList() {
      let opt = {
        token: this.$store.state.token,
        platform_id: 2, //平台ID（接口获取）
        page: this.page, //页数
        size: this.size //页大小
      }
      this.roleList(opt).then(res => {
        if (res.code == 1) {
          this.permissionList = res.data.list
          this.total = res.data.count
        } else {
          this.$message.error(res.msg);
        }
      })
    },

    delehandle(row) {
      let params = {
        token: this.$store.state.token,
        id: row.id,
      }
      this.DeleteRole(params).then(res => {
        if (res.code == 1) {
          this.$message.success("删除成功")
          this.GetRoleList()
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    handleClick(key, row) {
      switch (key) {
        case 1:
          this.$router.push({
            path: '/home/addRole',
             query: {
              role_id: 0
            }
          })
          break;
        case 2:
          this.$router.push({
            path: '/home/addRole',
            query: {
              role_id: row.id
            }
          })
          break;
        case 3:
          this.$confirm('此操作将删除该角色, 是否继续?', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',

          }).then(() => {
            /*  this.$message({
               type: 'success',
               message: '删除成功!'
             }); */
            this.delehandle(row)
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });

          break;

        default:
          break;
      }

    },

  },
  components: {

  },
};
</script>

<style lang="scss" scoped>
.page{
  text-align: center;
}
.role_div {
  .title {
    width: 100%;
    background: #fff;
    font-size: 20px;
    color: #000000;
    width: 100%;
    padding: 15px 32px;
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
  }

  .center_box {
    width: 100%;
    box-sizing: border-box;
    min-height: 800px;
    padding: 14px 25px;
    background-color: #e9e9e9;
  }

  .center_title {
    box-sizing: border-box;
    width: 100%;
    background-color: #fff;
    height: 76px;
    line-height: 76px;
    padding-left: 45px;
    font-weight: 600;
    color: #333;
    font-size: 16px;

    .center_left_btn {
      width: 93px;
      height: 32px;
      line-height: 32px;
      display: inline-block;
      text-align: center;
      font-size: 14px;
      color: #fff;
      background: #0084ff;
      border-radius: 2px;
    }
  }

  .center-contain {
    margin-top: 5px;
    min-height: 600px;
    background: #fff;
  }

  .RoleStatus {
    display: flex;
    justify-content: center;
    align-content: center;
    line-height: 100%;

    .name {
      display: inline-block;
    }

    .Yuan {
      width: 12px;
      height: 12px;
      background-color: #23ca18;
      border-radius: 50%;
      margin-right: 9px;
    }

    .RYuan {
      width: 12px;
      height: 12px;
      background-color: #f60a0a;
      border-radius: 50%;
      margin-right: 9px;
    }
  }
}
</style>
